<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="账户搜索">
                    <el-input  autocomplete="on" name="keyword" v-model="keyword" placeholder="输入编码、用户名、姓名、手机、Email搜索" clearable class="el-select-big"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getBranchOfficeMembers(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">账户列表</div>
            <el-table :data="userList" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn" :row-class-name="tableRowClassName" @row-click="handleRowClick">
                <!-- <el-table-column prop="ID" label="ID" width="100" align="center" sortable></el-table-column> -->
                <el-table-column prop="UserCode" label="员工编码" align="center"></el-table-column>
                <el-table-column prop="UserName" label="用户名" align="center"></el-table-column>
                <el-table-column prop="Job" label="部门岗位" align="center"></el-table-column>
                <el-table-column prop="BranchOfficeName" label="所属办事处" align="center"></el-table-column>
                <el-table-column prop="OwnerName" label="姓名" align="center"></el-table-column>
                <el-table-column prop="OwnerMobile" label="手机号码" align="center"></el-table-column>
                <el-table-column prop="OwnerEmail" label="Email" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleSerch(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog title="查看" :visible.sync="isDrawer" :before-close="handleClose" width="1200px" :close-on-click-modal="false">
            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">员工编码 ：</div>
                            <div>{{ userDetails.UserCode }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">用户名 ：</div>
                            <div>{{ userDetails.UserName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">所属办事处 ：</div>
                            <div>{{ userDetails.BranchOfficeName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">角色 ：</div>
                            <div>{{ userDetails.RoleName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">姓名 ：</div>
                            <div>{{ userDetails.BranchOfficeName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">手机号码 ：</div>
                            <div>{{ userDetails.OwnerMobile }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">Email ：</div>
                            <div>{{ userDetails.OwnerEmail }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">部门岗位 ：</div>
                            <div><span v-html="userDetails.Job"></span></div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">是否启用 ：</div>
                            <div><span style="color: #13ce66">启用</span></div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleClose()">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
export default {
    name: 'accountManagement',
    mixins: [myMixin],
    components: {
        Pagination
    },
    data() {
        return {
            keyword: '',
            userList: [],
            loadingBtn: false,
            isDrawer: false,
            userDetails: {
                BranchOfficeName: '',
                UserName: '',
                UserCode: '',
                RoleName: '',
                OwnerName: '',
                OwnerMobile: '',
                OwnerEmail: '',
                Job: ''
            }
        };
    },
    mounted() {
        this.onRefresh();
    },
    methods: {
        /*
        重置查询
        */
        onRefresh() {
            this.keyword = '';
            this.getBranchOfficeMembers(true);
        },
        /*
        列表查询
        */
        getBranchOfficeMembers(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            let params = {
                Page: this.paginationOptions.Page,
                PageSize: this.paginationOptions.PageSize,
                json: JSON.stringify({ keyword: this.keyword })
            };
            this.$newsApi
                .getBranchOfficeMembers(params)
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.userList = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        /*
        分页查询
        */
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.paginationOptions.Page = 1;
            this.getBranchOfficeMembers();
        },
        /*
        分页查询
        */
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getBranchOfficeMembers();
        },
        /*
        关闭弹窗
        */
        handleClose() {
            this.isDrawer = false;
        },
        /*
        打开弹窗
        */
        handleSerch(row) {
            this.isDrawer = true;
            this.userDetails = row;
        }
    }
};
</script>

<style lang="scss" scoped>
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
.content-head {
    padding: 15px 20px 5px 20px;
}
</style>
